var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: _vm.primaryServiceSize
          }
        },
        [
          _c(
            "gg-card",
            {
              staticClass: "fill-height"
            },
            [
              _c("gg-card-header", [_vm._v(" Primary Reference ")]),
              _c("v-card-text", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.decodeHtmlCharCodes(
                        _vm.filteredServices.primary_service.value
                      )
                    ) +
                    " "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.isAddonsAvailable
        ? _c(
            "v-col",
            {
              attrs: {
                cols: _vm.primaryServiceSize
              }
            },
            [
              _c(
                "gg-card",
                {
                  staticClass: "fill-height"
                },
                [
                  _c("gg-card-header", [_vm._v(" Cancellation Items ")]),
                  _c(
                    "v-card-text",
                    _vm._l(_vm.filteredServices.cancel_service, function(
                      service,
                      index
                    ) {
                      return _c(
                        "p",
                        {
                          key: index
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.decodeHtmlCharCodes(service.value)) +
                              " "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }